
<template>
  <div>
    <div class="seach">
      <div class="seach-bg">
        <div class="seach-bg-img">
          <img src="@/assets/seach/banner.png" alt="">
        </div>
        <div class="seach-bg-breadcrumb">
          <div class="seach-bg-breadcrumb-cont">
            <div class="seach-bg-breadcrumb-icon">
              <i class="el-icon-search"></i>
            </div>
            <div class="seach-bg-breadcrumb-input">
              <el-input v-model="seachInput" :placeholder="$t('seach.placeholder')" @keyup.enter.native="seachQuery"></el-input>
            </div>
            <div class="seach-bg-breadcrumb-btn">
              <div class="seach-bg-breadcrumb-btn-item">
                <button @click="seachQuery">{{ $t('seach.button') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="seach-cont">
        <div class="seach-cont-list">
          <div class="seach-cont-list-item" v-for="(item, index) in searchList" :key="index" @click="goDetail(item)">
            <div class="seach-cont-list-item-title">
              <strong>{{ item.title }}</strong>
            </div>
            <!-- <div class="seach-cont-list-item-content">{{ item.text }}</div> -->
            <div class="seach-cont-list-item-content" v-html="item.des"></div>
            <!-- <div class="seach-cont-list-item-iconText">
              <div class="seach-cont-list-item-iconText-icon">
                <img :src="item.img" alt="">
              </div>
              <div class="seach-cont-list-item-iconText-text">{{ item.breadcrumb }}</div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList } from '@/api/komo'
export default {
  name: 'seach',
  data() {
    return {
      seachInput:'',
      seachList: [
        {
          title: this.$t('seach.listTitle'),
          text: this.$t('seach.listText'),
          icon: require('@/assets/seach/book.png'),
          breadcrumb: this.$t('seach.breadcrumb')
        },
        {
          title: this.$t('seach.listTitle'),
          text: this.$t('seach.listText'),
          icon: require('@/assets/seach/book.png'),
          breadcrumb: this.$t('seach.breadcrumb')
        },
        {
          title: this.$t('seach.listTitle'),
          text: this.$t('seach.listText'),
          icon: require('@/assets/seach/book.png'),
          breadcrumb: this.$t('seach.breadcrumb')
        }
      ],
      searchList:[],
      isShow:true,
      chidList: {
        tabName: '',
        id:''
      }
    };
  },
  methods: {
    seachQuery () {
      console.log('seachInput111111', this.seachInput)
      this.searchData(this.seachInput)
    },
    goDetail (item) {
      this.$router.push({
        name: 'blogsDetail',
        params: {
          type:item.type,
          id: item.id
        }
      })
    },
    async searchData (search) {
      this.searchList = [];
      let params = {
        type:'',
        search:search
      }
      const searchDatalist = await getNewsList(params);
      this.searchList = searchDatalist.data.list;
    },
  },
  created () { 
    this.searchList = [];
  }
};
</script>

<style scoped>
/* 样式部分 */
.seach {
  width: 100%;
  height: 100%;
  background: #F8F9FC;
}
.seach-bg {
  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 2%;
}
.seach-bg-img{
  width: 100%;
  height: 580px;
}
.seach-bg-img img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.seach-bg-breadcrumb{
  width: 80%;
  height: 4vw;
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
  border-radius: 60px;
  position: absolute;
  top: calc(580px - 2vw);
  left: 10%;
  z-index: 1
}
.seach-bg-breadcrumb-cont{
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 12% 0 2%;
}
.seach-bg-breadcrumb-icon{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.seach-bg-breadcrumb-icon i {
  font-size: 1.2vw;
}
.seach-bg-breadcrumb-input{
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.seach-bg-breadcrumb-input :deep(.el-input){
  height: 100%;
}
.seach-bg-breadcrumb-input :deep(.el-input__inner){
  border: none;
  font-size: 1vw;
  height: 100%;
}
.seach-bg-breadcrumb-btn{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  width: 12%;
}
.seach-bg-breadcrumb-btn-item{
  width: 93%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4% 0;
}
.seach-bg-breadcrumb-btn-item  button{
  border: none;
  width: 100%;
  height: 100%;
  border-radius: 2vw 2vw 2vw 2vw;
  background-color: #1e1e1e;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  color: #fff;
  font-size: 1vw;
}


/* 内容 */
.seach-cont{
  width: 100%;
  height: 100%;
  padding: 4% 0 6%;
}
.seach-cont-list{
  width: 80%;
  height: 100%;
  margin: 0 auto;
}
.seach-cont-list-item{
  padding: 3% 0% 1%;
  border-bottom: 1px solid #95959591;
  display: flex;
  flex-direction: column;
  gap: 1vw;

}
.seach-cont-list-item-title{
  font-size: 1.5vw;
}
.seach-cont-list-item-content{
  font-size: 1.1vw;
  color: #1E1E1E;
}
.seach-cont-list-item-iconText{
  display: flex;
  gap: 0.5vw;
  align-items: center;
}
.seach-cont-list-item-iconText-icon{
  width: 1vw;
  height: 1vw;
  display: flex;
}
.seach-cont-list-item-iconText-icon img{
  width: 100%;
  height: 100%;
}
.seach-cont-list-item-iconText-text{
  color: #959595;
  font-size: 1vw;
}
</style>